import { createContext } from "react";
const DetailsMasterPageContext = createContext({});

export default DetailsMasterPageContext;
